import React from 'react';

// Helper component for the sort indicator icon (▲ or ▼)
const SortIndicator = ({ direction }) => {
    if (!direction) return null;
    return direction === 'ascending' ? ' ▲' : ' ▼';
};

const FeedInventoryTable = ({ inventory, isLoading, requestSort, sortConfig, onSelectFeedItem }) => {
    if (isLoading) return <div className="text-center py-10">Loading inventory...</div>;
    if (inventory.length === 0) return (
        <div className="text-center py-16 border-2 border-dashed border-gray-300 rounded-lg">
            <h3 className="text-lg font-medium text-gray-900">No Feed Items Found</h3>
            <p className="mt-1 text-sm text-gray-500">Try adjusting your search or filter.</p>
        </div>
    );

    const getSortDirection = (key) => {
        return sortConfig && sortConfig.key === key ? sortConfig.direction : undefined;
    };

    return (
        <div className="overflow-x-auto bg-white rounded-lg shadow">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <button onClick={() => requestSort('name')} className="font-bold text-gray-500 hover:text-gray-700 flex items-center">
                                Feed Name
                                <span className="ml-1"><SortIndicator direction={getSortDirection('name')} /></span>
                            </button>
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <button onClick={() => requestSort('stock')} className="font-bold text-gray-500 hover:text-gray-700 flex items-center">
                                Current Stock (kg)
                                <span className="ml-1"><SortIndicator direction={getSortDirection('stock')} /></span>
                            </button>
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <button onClick={() => requestSort('unitPrice')} className="font-bold text-gray-500 hover:text-gray-700 flex items-center">
                                Latest Price/kg (₹)
                                <span className="ml-1"><SortIndicator direction={getSortDirection('unitPrice')} /></span>
                            </button>
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Protein %</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fat %</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {inventory.map(item => {
                        const isLowStock = item.stock <= item.lowStockThreshold;
                        return (
                            <tr key={item.id} onClick={() => onSelectFeedItem(item)} className={`cursor-pointer ${isLowStock ? 'bg-red-50 hover:bg-red-100' : 'hover:bg-gray-50'}`}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-indigo-600">{item.name}</td>
                                <td className={`px-6 py-4 whitespace-nowrap text-sm font-bold ${isLowStock ? 'text-red-600' : 'text-gray-800'}`}>{item.stock.toFixed(2)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.unitPrice.toFixed(2)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.protein || 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.fat || 'N/A'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default FeedInventoryTable;